import { Component, inject, OnInit } from '@angular/core';
import { gungAddRemoveSpinner, GungModalService } from 'gung-standard';
import { JeevesCustomerDetailsComponent } from 'gung-standard-jeeves';
import { environment as env } from '../../../environments/environment';

@Component({
    selector: 'colmec-customer-details',
    templateUrl: './colmec-customer-details.component.html',
    styleUrls: ['./colmec-customer-details.component.scss'],
    standalone: false
})
export class ColmecCustomerDetailsComponent extends JeevesCustomerDetailsComponent implements OnInit {
  private gungModalService = inject(GungModalService);

  showOrders = false;
  isNoPrice = false;

  isAdmin: boolean;
  enableClaim = env.enableClaim;

  ngOnInit() {
    super.ngOnInit();

    this.authService.getCurrentUser().subscribe(user => {
      this.isAdmin = user.roles.indexOf('ADMIN') > -1;
      this.showOrders = !(user.roles.length === 1 && user.roles.includes('USER'));
      this.isNoPrice = user.roles.length > 0 && user.roles.includes('NOPRICE');
    })
  }

  saveNote({ target }) {
    gungAddRemoveSpinner(target);
    this.customerService.updateCustomer(this.customer).subscribe(
      result => {
        this.gungModalService
          .openConfirmYesNoModal(undefined, 'CUSTOMER_UPDATE_SUCCESS', { size: 'sm' }, 'OK', null)
          .then(_ => {});
      },
      error => {
        gungAddRemoveSpinner(target);
      },
      () => {
        gungAddRemoveSpinner(target);
      }
    );
  }
}
